import { getDisplayToken } from '@/domain/hooks/useDisplayToken'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { Token } from '@/domain/types/Token'
import { SuccessViewCheckmark } from '@/features/dialogs/common/components/success-view/SuccessViewCheckmark'
import { SuccessViewContent } from '@/features/dialogs/common/components/success-view/SuccessViewContent'
import { SuccessViewProceedButton } from '@/features/dialogs/common/components/success-view/SuccessViewProceedButton'
import { SuccessViewSummaryPanel } from '@/features/dialogs/common/components/success-view/SuccessViewSummaryPanel'
import { TokenIcon } from '@/ui/atoms/token-icon/TokenIcon'
import { Typography } from '@/ui/atoms/typography/Typography'
import { useChainId } from 'wagmi'

export interface DepositSuccessViewProps {
  token: Token
  amount: NormalizedUnitNumber
  onProceed: () => void
  proceedText?: string
}

export function DepositSuccessView({
  token,
  amount,
  onProceed,
  proceedText = 'View vault details',
}: DepositSuccessViewProps) {
  const chainId = useChainId()
  const displayToken = getDisplayToken(chainId, token)

  return (
    <SuccessViewContent>
      <SuccessViewCheckmark isModal />
      <SuccessViewSummaryPanel title="Deposited">
        <div className="flex items-center gap-2">
          <TokenIcon token={token} className="h-6" />
          <span className="font-semibold">{displayToken.symbol}</span>
        </div>
        <div className="flex grow flex-col">
          <Typography className="text-right font-primary">{token.format(amount, { style: 'auto' })}</Typography>
        </div>
      </SuccessViewSummaryPanel>
      <SuccessViewProceedButton onProceed={onProceed}>{proceedText}</SuccessViewProceedButton>
    </SuccessViewContent>
  )
}
